import loadable from '@loadable/component';

export const ApplicationHistoryPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "userDashboard/ApplicationHistoryPageContainer" */
      './ApplicationHistoryPageContainer'
    ),
);
